import { Box, BoxProps } from '@mui/material';

import { Loader } from './Loader';

export const BoxLoader = (props: BoxProps) => (
    <Box height="300px" position="relative" {...props}>
        <Loader />
    </Box>
);
